export type CompanyRemunerationLoadPlan = {
  loadSettings: boolean;
  loadReferenceDocument: boolean;
  loadTemplates: boolean;
};

export type CompanyRemunerationTemplatesView = {
  templatesLoading: boolean;
  missingOrganization: boolean;
};

export const getCompanyRemunerationLoadPlan = (params: {
  companyId: string | undefined;
  organizationId: string | undefined;
}): CompanyRemunerationLoadPlan => {
  const hasCompany = Boolean(params.companyId);
  return {
    loadSettings: hasCompany,
    loadReferenceDocument: hasCompany,
    loadTemplates: hasCompany && Boolean(params.organizationId),
  };
};

export const getCompanyRemunerationTemplatesView = (params: {
  consultantOrganizationResolved: boolean;
  templatesRequestLoading: boolean;
  organizationId: string | undefined;
}): CompanyRemunerationTemplatesView => ({
  templatesLoading: !params.consultantOrganizationResolved || params.templatesRequestLoading,
  missingOrganization: params.consultantOrganizationResolved && params.organizationId === undefined,
});

/** Picks the first free copy name; `formatCopyName(1)` then `formatCopyName(2)` … until unused. */
export const generateUniqueCopyName = (
  existingNames: ReadonlyArray<string>,
  formatCopyName: (copyIndex: number) => string
): string => {
  const existingNamesSet = new Set(existingNames);
  let copyIndex = 1;
  while (existingNamesSet.has(formatCopyName(copyIndex))) {
    copyIndex += 1;
  }
  return formatCopyName(copyIndex);
};
